export class PolicyStaffObject {
    Id: number = 0;
    PolicyId: number;
    StaffId: number;
    IsDeleted: boolean = false;
    Staff: any;
    IsInfluencedStaff: boolean;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/notification-tab-form.ts